jQuery(document).ready(function(){
  var swiper = new Swiper(".feater-holder-slider", {
    slidesPerView: 2,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    autoplay: {
      delay: 2500,
    },
    pagination: {
      el: ".swiper-pagination",
    },
    breakpoints: {       
      320: {       
        slidesPerView: 1,
        spaceBetween: 10     
      },          
      770: {       
        slidesPerView: 2,       
        spaceBetween: 50     
      },   

      771: {       
        slidesPerView: 2,       
        spaceBetween: 30     
      } 
    } 
  });	
});